import { call, put, takeLatest } from "redux-saga/effects"
import { messageFailed, messageSuccess } from "../../utils/message"
import { setLanguage } from "../../utils/i18n"
import axios from "axios"
import {
  GET_USER_WATCHER,
  PUT_USER_WATCHER,
  PASSWORD_USER_WATCHER,
  GET_LANGUAGE_WATCHER,
  PUT_LANGUAGE_WATCHER,
} from "./constants"
import {
  getUserWatcher,
  getUserSuccess,
  getUserFailed,
  getLanguageSuccess,
  putLanguageSuccess,
  getLanguageFailed,
  putLanguageFailed,
  passwordUserSuccess,
  passwordUserFailed,
} from "./actions"
import { getUserWatcher as getUserInfo } from "../UserHeaderBox/actions"
import { LOCAL_TOKEN, LOCAL_USER_ID } from "../../utils/storage"

// GET LANGUAGE
export function getLanguageApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}language/`,
  })
}
export function* getLanguageSaga() {
  try {
    const {
      data: { data },
    } = yield call(getLanguageApi)

    yield put(getLanguageSuccess(data))
  } catch (error) {
    yield put(getLanguageFailed())
    returnMessage(error)
  }
}
// PUT LANGUAGE
export function putLanguageApi(data = {}) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}users/${LOCAL_USER_ID()}/language`,
    data,
  })
}

export function* putLanguageSaga(action) {
  try {
    const data = yield call(putLanguageApi, action.payload)
    setLanguage(action.payload.locale)
    /*  yield put(getUserInfo())
    yield put(getUserWatcher()) */
    yield put(putLanguageSuccess(data))
    messageSuccess(
      action.payload.locale == "es"
        ? "Los cambios se han guardado correctamente"
        : "Changes have been saved successfully"
    )
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  } catch (error) {
    
    /* yield put(getUserWatcher()) */
    returnMessage(error)
  }
}
// GET USER
export function getUserApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}users/${LOCAL_USER_ID()}`,
  })
}

export function* getUserSaga() {
  try {
    const {
      data: { data },
    } = yield call(getUserApi)

    yield put(getUserSuccess(data))
  } catch (error) {
    // yield put(getUserFailed());
    returnMessage(error)
  }
}

// PUT USER
export function putUserApi(data = {}) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}users/${LOCAL_USER_ID()}`,
    data,
  })
}

export function* putUserSaga(action) {
  try {
    const data = yield call(putUserApi, action.payload)
    yield put(getUserInfo())
    yield put(getUserWatcher())
    returnMessage(data)
  } catch (error) {
    yield put(getUserWatcher())
    returnMessage(error)
  }
}

// PASSWORD USER
export function passwordUserApi(data = {}) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}users/me/password-reset`,
    data,
  })
}

export function* passwordUserSaga(action) {
  try {
    const data = yield call(passwordUserApi, action.payload)
    yield put(passwordUserSuccess())
    returnMessage(data)
  } catch (error) {
    yield put(passwordUserFailed())
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* myAccountSaga() {
  yield takeLatest(GET_USER_WATCHER, getUserSaga)
  yield takeLatest(PUT_USER_WATCHER, putUserSaga)
  yield takeLatest(PASSWORD_USER_WATCHER, passwordUserSaga)
  yield takeLatest(GET_LANGUAGE_WATCHER, getLanguageSaga)
  yield takeLatest(PUT_LANGUAGE_WATCHER, putLanguageSaga)
}
